import React, { useEffect, useState } from "react";
import Post from "../services/Post";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  InputNumber,
  message,
  Radio,
  Row,
  Skeleton,
  Spin,
  Tag,
  Typography,
} from "antd";
import io from "socket.io-client";

const DTHdetails = () => {
  const [loading, setLoading] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState("wallet");
  const [processing, setProcessing] = useState(false);
  const [dth, setDth] = useState({});
  const [isError, setIsError] = useState(false);
  const [amount, setAmount] = useState();

  const navigate = useNavigate();
  const location = useLocation();
  const phoneNumber = location.state.phoneNumber;
  const paysprintId = location.state.paysprintId;

  const dthData = () => {
    setLoading(true);
    Post.HlrDthData({ number: phoneNumber, operator: paysprintId })
      .then((res) => {
        console.log(res);
        // if (res.error) {
        //     message.error(res.error);
        //     return;
        // }
        console.log(res.data.response_code);
        if (res.data.response_code == 1) {
          console.log("here");
          setDth(res.data.info[0]);
          setAmount(res.data.info[0].MonthlyRecharge);
        } else {
          setIsError(true);
          message.error(
            res.data.message ? res.data.message : "No data recieved"
          );
        }
      })
      .catch((err) => {
        setIsError(true);
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  // const pay_now = async () => {
  //     return new Promise((resolve, reject) => {

  //         if (!amount) {
  //             reject("Amount not found!");
  //         }

  //         const options = {
  //             description: `DTH Bill Payment`,
  //             image: 'https://rebatedekho.com/website/img/logo.png',
  //             currency: 'INR',
  //             key: 'rzp_test_1DP5mmOlF5G5ag', // Replace with your Razorpay key
  //             amount: amount * 100, // Razorpay accepts amount in paise
  //             name: 'Rebate Dekho',
  //             prefill: {
  //                 email: 'rebateDekho@gmail.com',
  //                 contact: '9191919191',
  //                 name: 'RebateDekho',
  //             },
  //             theme: { color: '#a6cc43' },
  //             handler: (response) => {
  //                 console.log('Payment successful!', response);
  //                 resolve(response.razorpay_payment_id); // Resolve the Promise with payment ID
  //             },
  //             modal: {
  //                 ondismiss: () => {
  //                     console.log('Transaction was cancelled.');
  //                     reject('Transaction cancelled'); // Reject the promise if the transaction is cancelled
  //                 },
  //             },
  //         };

  //         // Initialize Razorpay
  //         const rzp = new window.Razorpay(options);
  //         rzp.open();
  //     });
  // };

  const pay_now = async () => {
    try {
      if (!amount) {
        message.error("Amount not found!");
        return null;
      }
  
      setProcessing(true);
  
      const res = await Post.PaymentLink(amount);
      console.log(res);
  
      const { paymentLink, order_id } = res.data;
  
      if (!paymentLink || !order_id) {
        message.error("Failed to retrieve payment link!");
        setProcessing(false);
        return null;
      }
  
      const paymentWindow = window.open(
        paymentLink,
        "_blank",
        "width=1000,height=800"
      );
  
      if (!paymentWindow) {
        message.error("Popup blocked! Please allow popups and try again.");
        setProcessing(false);
        return null;
      }
  
      let popupClosed = false;
  
      return new Promise((resolve, reject) => {
        const checkPopupClosed = setInterval(() => {
          if (paymentWindow.closed) {
            clearInterval(checkPopupClosed);
            popupClosed = true;
            message.error("Payment popup closed before completion!");
            setProcessing(false);
            reject(null);
          }
        }, 1000);
  
        const socket = io.connect("https://socket.rebatedekho.com");

        // Join a unique room for this payment
        console.log(order_id);
        socket.emit("join-room", order_id);
        console.log('room joined');

        socket.on("callback-event", (data) => {
          console.log("Payment callback received:", data);
          const parsedData = data;
  
          if (popupClosed) return;
  
          if (parsedData.STATUS_CODE === "RP000") {
            message.success(parsedData.ERROR_DESC);
            clearInterval(checkPopupClosed);
            socket.disconnect();
            resolve(parsedData.ORDER_ID);
          } else {
            message.error(parsedData.ERROR_DESC);
          }
        });
      });
    } catch (error) {
      message.error("Something went wrong while processing payment!");
      console.error(error);
      setProcessing(false);
      return null;
    }
  };

  const handlePayment = async () => {
    if (!dth) {
      message.error("Bill details are missing. Cannot proceed with payment.");
      return;
    }

    if (amount == "0.0") {
      message.info("No due amount to pay!");
      return;
    }

    // Set processing state to true
    setProcessing(true);

    try {
      console.log({ paysprintId });

      if (paymentMethod === "online") {
        const payId = await pay_now();

        if (payId) {
          const send = {
            operator_id: paysprintId,
            latitude: 0.0,
            longitude: 0.0,
            method: paymentMethod,
            pay_id: payId,
            remark: `Your DTH bill payment is successful`,
            description: `Your DTH bill payment is successful`,
            status: `success`,
          };

          send.amount = amount;
          send.canumber = phoneNumber;

          console.log("data to send", send);

          const res = await Post.PayBill(send);
          console.log("res =====", res);

          if (res) {
            if (res.error) {
              console.log(res.error);
              message.error("Something went wrong");
              navigate(`/user/home`);
            } else {
              console.log("successss");
              message.success(res.data.message);
              navigate(`/user/reciept/${res.data.wallet_id}`);
            }
          }
        }
      } else {
        const send = {
          operator_id: paysprintId,
          latitude: 0.0,
          longitude: 0.0,
          method: paymentMethod,
        };

        send.amount = amount;
        send.canumber = phoneNumber;

        console.log("send data", send);

        const res = await Post.PayBill(send);
        console.log(res);

        if (res) {
          if (res.error) {
            console.log(res.error);
            message.error("Something went wrong");
            navigate(`/user/home`);
          } else {
            if (!res.data.status) {
              console.log(res);
              if (res.error) {
                console.log(res.error);
                message.error("Something went wrong");
                navigate(`/user/home`);
              } else {
                console.log(res.data?.message);
                message.error("Something went wrong");
                navigate(`/user/home`);
              }
            } else {
              console.log("successs!!!!");
              message.success(res.data.message);
              navigate(`/user/reciept/${res.data.wallet_id}`);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error in payment:", error);
      message.error("Something went wrong");
    } finally {
      // Reset processing state
      setProcessing(false);
    }
  };

  useEffect(() => {
    dthData();
  }, []);

  return (
    <div className="layout-content">
      <Row gutter={[24, 24]} justify="center">
        <Col>
          {!isError ? (
            <Card
              title={`DTH Bill Details`}
              bordered={true}
              style={{ width: 500 }}
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Typography.Text strong>Customer Name:</Typography.Text>
                </Col>
                <Col span={12}>
                  {loading ? (
                    <Skeleton.Input active={true} size="default" />
                  ) : (
                    <Typography.Text>{dth.customerName}</Typography.Text>
                  )}
                </Col>

                <Col span={12}>
                  <Typography.Text strong>Balance:</Typography.Text>
                </Col>
                <Col span={12}>
                  {loading ? (
                    <Skeleton.Input active={true} size="default" />
                  ) : (
                    <Typography.Text>{dth.Balance}</Typography.Text>
                  )}
                </Col>

                <Col span={12}>
                  <Typography.Text strong>Next Recharge Date:</Typography.Text>
                </Col>
                <Col span={12}>
                  {loading ? (
                    <Skeleton.Input active={true} size="default" />
                  ) : (
                    <Typography.Text>{dth.NextRechargeDate}</Typography.Text>
                  )}
                </Col>

                <Col span={12}>
                  <Typography.Text strong>Current Plan:</Typography.Text>
                </Col>
                <Col span={12}>
                  {loading ? (
                    <Skeleton.Input active={true} size="default" />
                  ) : (
                    <Typography.Text>₹ {dth.MonthlyRecharge}</Typography.Text>
                  )}
                </Col>

                <Col span={12}>
                  <Typography.Text strong>Plan Name:</Typography.Text>
                </Col>
                <Col span={12}>
                  {loading ? (
                    <Skeleton.Input active={true} size="default" />
                  ) : (
                    <Typography.Text>{dth.planname}</Typography.Text>
                  )}
                </Col>

                <Col span={12}>
                  <Typography.Text strong>Status:</Typography.Text>
                </Col>
                <Col span={12}>
                  {loading ? (
                    <Skeleton.Input active={true} size="default" />
                  ) : (
                    <Tag color="blue">{dth.status}</Tag>
                  )}
                </Col>

                <Col span={12}>
                  <Typography.Text strong>Total Amount:</Typography.Text>
                </Col>
                <Col span={12}>
                  {loading ? (
                    <Skeleton.Input active={true} size="default" />
                  ) : (
                    <InputNumber
                      defaultValue={dth.MonthlyRecharge}
                      addonBefore="₹"
                      onChange={(e) => setAmount(e)}
                    />
                    // <Tag color="green" style={{width}}>₹{dth.MonthlyRecharge}</Tag>
                  )}
                </Col>
              </Row>
              <Row>
                <Typography.Text strong className="mt-25">
                  Select Payment Method:
                </Typography.Text>
              </Row>
              <Row>
                <Radio.Group
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  value={paymentMethod}
                  style={{ display: "block", margin: "20px 0" }}
                >
                  <Radio value="online" disabled>
                    Online Payment
                  </Radio>
                  <Radio value="wallet">Wallet</Radio>
                </Radio.Group>
                <Button
                  className="form-btn"
                  block
                  onClick={handlePayment}
                  disabled={loading || processing}
                >
                  {processing ? <Spin size="small" /> : "Pay Now"}
                </Button>
                <Button
                  className="back-btn"
                  block
                  onClick={() => navigate(-1)}
                  disabled={loading || processing}
                >
                  Go Back
                </Button>
              </Row>
            </Card>
          ) : (
            <>
              <Typography.Text type="danger">
                Failed to fetch bill details.
              </Typography.Text>
              <Button
                className="back-btn"
                block
                onClick={() => navigate(-1)}
                disabled={loading || processing}
              >
                Go Back
              </Button>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DTHdetails;
